var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        width: "100%",
        overflow: "auto",
        height: "calc(100vh - 64px - 48px)",
      },
    },
    [
      _c("div", { staticClass: "index_box fix" }, [
        _c("div", { staticClass: "box_item l" }, [
          _c("div", { staticClass: "item_title" }, [_vm._v(" 工作看板 ")]),
          _c("div", { staticClass: "item_box " }, [
            _c("div", { staticClass: "item_top fix" }, [
              _vm._m(0),
              _c("div", { staticClass: "agency_sth l" }, [
                _vm._v(" 待办事项 "),
                _vm.homePageData.todayTaskSum
                  ? _c("span", { staticClass: "agency_num" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            1 + _vm.momentList.length + _vm.msgList.length
                          ) +
                          " "
                      ),
                    ])
                  : _c("span", { staticClass: "agency_num" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.momentList.length + _vm.msgList.length) +
                          " "
                      ),
                    ]),
              ]),
            ]),
            _c("div", { staticClass: "agency_box" }, [
              _c("div", { staticClass: "agency_item" }, [
                _c("div", { staticClass: "regular_follow" }, [
                  _vm._v(" 定期跟进项目 "),
                ]),
                _c("div", { staticClass: "agency_rate" }, [
                  _c(
                    "div",
                    {
                      staticClass: "contacts_num",
                      staticStyle: { cursor: "pointer" },
                      on: { click: _vm.goClueToday },
                    },
                    [
                      _vm._v(
                        " 你今日还有" +
                          _vm._s(
                            _vm.homePageData.todayTaskSum -
                              _vm.homePageData.hadFinishSum
                          ) +
                          "个线索需跟进 "
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "today_rate" }, [
                    _vm._v(
                      "今日完成进度（" +
                        _vm._s(_vm.homePageData.hadFinishSum) +
                        "/" +
                        _vm._s(_vm.homePageData.todayTaskSum) +
                        ")"
                    ),
                  ]),
                  _c("div", { staticClass: "progress_bar" }, [
                    _vm.homePageData.todayTaskSum -
                    _vm.homePageData.hadFinishSum
                      ? _c("div", {
                          staticClass: "progress",
                          style: {
                            width:
                              "calc(" +
                              (_vm.homePageData.hadFinishSum /
                                _vm.homePageData.todayTaskSum) *
                                100 +
                              "%)",
                          },
                        })
                      : _vm.homePageData.todayTaskSum ===
                        _vm.homePageData.hadFinishSum
                      ? _c("div", {
                          staticClass: "progress",
                          style: " width:100%",
                        })
                      : _c(
                          "div",
                          { staticClass: "progress", style: "width:0" },
                          [_vm._v("33")]
                        ),
                  ]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "agency_item" },
                [
                  _c("div", { staticClass: "regular_follow" }, [
                    _vm._v(" 日常任务 "),
                  ]),
                  _vm.momentList.length || _vm.msgList.length
                    ? [
                        _vm._l(_vm.momentList, function (item, index) {
                          return _c(
                            "div",
                            {
                              key: "moment" + index,
                              staticClass: "agency_rate",
                            },
                            [
                              _c("div", { staticClass: "agency_title fix" }, [
                                _c("div", { staticClass: "be_overdue l" }, [
                                  _vm._v("待办"),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "be_overdue_name l" },
                                  [_vm._v(_vm._s(item.taskTitle))]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "be_overdue_time r" },
                                  [_vm._v(_vm._s(item.createDate))]
                                ),
                              ]),
                              _c("div", { staticClass: "contacts_num" }, [
                                _vm._v(_vm._s(item.content)),
                              ]),
                              _c("div", { staticClass: "today_rate" }, [
                                _vm._v("任务类型：朋友圈任务"),
                              ]),
                              _c("div", { staticClass: "today_rate" }, [
                                _vm._v("责任人：" + _vm._s(item.userName)),
                              ]),
                            ]
                          )
                        }),
                        _vm._l(_vm.msgList, function (item, index) {
                          return _c(
                            "div",
                            {
                              key: "mission" + index,
                              staticClass: "agency_rate",
                            },
                            [
                              _c("div", { staticClass: "agency_title fix" }, [
                                _c("div", { staticClass: "be_overdue l" }, [
                                  _vm._v("待办"),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "be_overdue_name l" },
                                  [_vm._v(_vm._s(item.taskTitle))]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "be_overdue_time r" },
                                  [_vm._v(_vm._s(item.createDate))]
                                ),
                              ]),
                              _c("div", { staticClass: "contacts_num" }, [
                                _vm._v(_vm._s(item.taskContent)),
                              ]),
                              _c("div", { staticClass: "today_rate" }, [
                                _vm._v("任务类型：群发任务"),
                              ]),
                              _c("div", { staticClass: "today_rate" }, [
                                _vm._v("责任人：" + _vm._s(item.userName)),
                              ]),
                            ]
                          )
                        }),
                      ]
                    : _vm._e(),
                  !_vm.momentList.length && !_vm.msgList.length
                    ? _c("div", { staticStyle: { "margin-top": "20px" } }, [
                        _vm._v(" 暂无任务 "),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "box_item l" }, [
          _c(
            "div",
            {
              staticClass: "no_contact_box",
              staticStyle: { height: "auto", position: "relative" },
            },
            [
              _c("div", { staticClass: "item_top fix" }, [
                _vm._m(1),
                _c(
                  "div",
                  { staticClass: "agency_sth l" },
                  [
                    _vm._v(" 销售漏斗 "),
                    _c(
                      "a-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.visible = true
                          },
                        },
                      },
                      [_vm._v("筛选")]
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", {
                staticStyle: {
                  width: "100%",
                  height: "350px",
                  "overflow-y": "hidden",
                },
                attrs: { id: "myChart" },
              }),
              _c("ul", { staticClass: "percent" }, [
                _c("li", { staticStyle: { color: "#000" } }, [
                  _vm._v(
                    "意向客户占比" +
                      _vm._s(_vm.percent.percentHadClubCust) +
                      "%"
                  ),
                ]),
                _c("li", [
                  _vm._v(
                    "线索跟进率" +
                      _vm._s(_vm.percent.percentHadReportClue) +
                      "%"
                  ),
                ]),
                _c("li", [
                  _vm._v(
                    "成交转化率" + _vm._s(_vm.percent.percentSuccessClue) + "%"
                  ),
                ]),
                _c("li", [
                  _vm._v(
                    "保客再购率" + _vm._s(_vm.percent.percentCustBuy) + "%"
                  ),
                ]),
              ]),
              _c(
                "a-drawer",
                {
                  attrs: {
                    title: null,
                    placement: "top",
                    height: 300,
                    closable: false,
                    visible: _vm.visible,
                    "get-container": false,
                    "wrap-style": { position: "absolute" },
                  },
                  on: { close: _vm.onClose },
                },
                [
                  _c("div", { staticClass: "search" }, [
                    _c(
                      "div",
                      { staticClass: "item" },
                      [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("时间："),
                        ]),
                        _c("a-range-picker", {
                          staticStyle: { width: "75%" },
                          attrs: { valueFormat: "YYYY-MM-DD" },
                          model: {
                            value: _vm.dataRangeAgain,
                            callback: function ($$v) {
                              _vm.dataRangeAgain = $$v
                            },
                            expression: "dataRangeAgain",
                          },
                        }),
                      ],
                      1
                    ),
                    !_vm.onlyOne
                      ? _c(
                          "div",
                          { staticClass: "item" },
                          [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("经理部："),
                            ]),
                            _c("a-select", {
                              attrs: { options: _vm.deptList },
                              on: { change: _vm.handleChangeDept },
                              model: {
                                value: _vm.deptId,
                                callback: function ($$v) {
                                  _vm.deptId = $$v
                                },
                                expression: "deptId",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "item" },
                      [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("经销商："),
                        ]),
                        _vm.onlyOne
                          ? _c("a-button", { attrs: { disabled: "" } }, [
                              _vm._v(_vm._s(_vm.theOne)),
                            ])
                          : _vm._e(),
                        !_vm.onlyOne
                          ? _c(
                              "a-button",
                              {
                                on: {
                                  click: function ($event) {
                                    _vm.dealderModalShow = true
                                  },
                                },
                              },
                              [
                                !_vm.dealerId
                                  ? _c("span", [_vm._v("请选择经销商")])
                                  : _vm._e(),
                                _vm.dealerId
                                  ? _c("span", [
                                      _vm._v(_vm._s(_vm.showDealerName)),
                                    ])
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "a-modal",
                          {
                            attrs: {
                              forceRender: "",
                              title: "经销商",
                              width: 500,
                              "ok-text": "确认",
                              "cancel-text": "取消",
                            },
                            on: {
                              ok: _vm.chooseDealer,
                              cancel: function ($event) {
                                _vm.dealderModalShow = false
                                _vm.dealerKws = ""
                                _vm.isChosen = false
                              },
                            },
                            model: {
                              value: _vm.dealderModalShow,
                              callback: function ($$v) {
                                _vm.dealderModalShow = $$v
                              },
                              expression: "dealderModalShow",
                            },
                          },
                          [
                            _c("a-input-search", {
                              staticStyle: { "margin-bottom": "10px" },
                              attrs: {
                                placeholder: "请输入关键字",
                                size: "large",
                              },
                              model: {
                                value: _vm.dealerKws,
                                callback: function ($$v) {
                                  _vm.dealerKws = $$v
                                },
                                expression: "dealerKws",
                              },
                            }),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-bottom": "5px",
                                  float: "right",
                                  "font-size": "15px",
                                  "font-weight": "700",
                                  color: "rgb(2,84,96)",
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.dealerNumber) + "条数据 "
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-bottom": "5px",
                                  float: "left",
                                  "font-size": "15px",
                                  "font-weight": "700",
                                  color: "rgb(2,84,96)",
                                },
                              },
                              [_vm._v(" " + _vm._s(_vm.dealerDeptName) + " ")]
                            ),
                            _c(
                              "a-radio-group",
                              {
                                staticStyle: {
                                  width: "452px",
                                  height: "355px",
                                  "overflow-y": "scroll",
                                  "overflow-x": "hidden",
                                },
                                attrs: { name: "radioName" },
                                on: { change: _vm.changeRadio },
                                model: {
                                  value: _vm.dealerIdModal,
                                  callback: function ($$v) {
                                    _vm.dealerIdModal = $$v
                                  },
                                  expression: "dealerIdModal",
                                },
                              },
                              [
                                _vm._l(
                                  _vm.dealerSearchModalList,
                                  function (item, index) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          key: index,
                                          class: {
                                            "radio-chose":
                                              _vm.dealerIdModal ===
                                              item.dealerIdModal,
                                          },
                                          staticStyle: {
                                            height: "40px",
                                            "padding-left": "20px",
                                            "padding-right": "20px",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.chooseOrNot(
                                                item.dealerIdModal
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "a-radio",
                                            {
                                              staticStyle: {
                                                height: "40px",
                                                "padding-top": "6px",
                                              },
                                              attrs: {
                                                value: item.dealerIdModal,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.dealerNameModal) +
                                                  " "
                                              ),
                                              _c("img", {
                                                staticStyle: {
                                                  width: "20px",
                                                  float: "right",
                                                  display: "none",
                                                },
                                                attrs: {
                                                  src: require("@/assets/img/right.png"),
                                                  alt: "",
                                                },
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  }
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "item" },
                      [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("城市："),
                        ]),
                        _c("a-cascader", {
                          attrs: {
                            options: _vm.cityList,
                            "expand-trigger": "hover",
                            fieldNames: {
                              label: "areaName",
                              value: "areaCode",
                              children: "children",
                            },
                            placeholder: "请选择城市",
                          },
                          on: { change: _vm.handleChangeCity },
                          model: {
                            value: _vm.cityId,
                            callback: function ($$v) {
                              _vm.cityId = $$v
                            },
                            expression: "cityId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "item" },
                      [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("品系："),
                        ]),
                        _c("a-select", {
                          attrs: { options: _vm.strainList },
                          model: {
                            value: _vm.strainId,
                            callback: function ($$v) {
                              _vm.strainId = $$v
                            },
                            expression: "strainId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "item" },
                      [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("客户类型："),
                        ]),
                        _c("a-select", {
                          attrs: { options: _vm.custList },
                          model: {
                            value: _vm.custCategoryId,
                            callback: function ($$v) {
                              _vm.custCategoryId = $$v
                            },
                            expression: "custCategoryId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "opt" },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.listData },
                          },
                          [_vm._v("筛选")]
                        ),
                        _c("a-button", { on: { click: _vm.reset } }, [
                          _vm._v("重置"),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "no_contact_box",
              staticStyle: { "margin-top": "15px", height: "486px" },
            },
            [
              _c("div", { staticClass: "item_top_one fix" }, [
                _c(
                  "div",
                  {
                    staticClass: "item_top_small item_top_small_again l",
                    class: { active: _vm.current === 1 },
                    on: {
                      click: function ($event) {
                        return _vm.changeList(1)
                      },
                    },
                  },
                  [
                    _vm._m(2),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                          width: "85%",
                        },
                      },
                      [
                        _c("div", { staticClass: "agency_sth" }, [
                          _vm._v(" 未跟进客户 "),
                          _c("span", { staticClass: "agency_num" }, [
                            _vm._v(_vm._s(_vm.noContactDataSize)),
                          ]),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: { "align-self": "center" },
                            on: {
                              click: function ($event) {
                                return _vm.toCustList(-1)
                              },
                            },
                          },
                          [_vm._v("更多 >>")]
                        ),
                      ]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "item_top_small l fix",
                    class: { active: _vm.current === 2 },
                    on: {
                      click: function ($event) {
                        return _vm.changeList(2)
                      },
                    },
                  },
                  [
                    _vm._m(3),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                          width: "85%",
                        },
                      },
                      [
                        _c("div", { staticClass: "agency_sth" }, [
                          _vm._v(" 跟进中客户 "),
                          _c("span", { staticClass: "agency_num" }, [
                            _vm._v(_vm._s(_vm.contactCustDataSize)),
                          ]),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: { "align-self": "center" },
                            on: {
                              click: function ($event) {
                                return _vm.toCustList(1)
                              },
                            },
                          },
                          [_vm._v("更多 >>")]
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
              _vm.current === 1
                ? _c(
                    "div",
                    { staticClass: "no_contact" },
                    [
                      _vm.noContactData.length
                        ? _vm._l(_vm.noContactData, function (item) {
                            return _c(
                              "div",
                              {
                                key: item.custId,
                                staticClass: "contact_item fix",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "contact_head l" },
                                  [
                                    item.avatar
                                      ? _c("img", {
                                          attrs: {
                                            src: _vm._f("fileWxPath")(
                                              item.avatar
                                            ),
                                            alt: "",
                                          },
                                        })
                                      : _c("a-avatar", {
                                          attrs: {
                                            shape: "square",
                                            size: 55,
                                            icon: "user",
                                          },
                                        }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "customer_details l" },
                                  [
                                    _c("div", { staticClass: "contact_name" }, [
                                      _vm._v(_vm._s(item.custName)),
                                      _c("span", [_vm._v("@微信")]),
                                    ]),
                                    _c("div", { staticClass: "customer_com" }, [
                                      _vm._v(
                                        " 客户企业：" +
                                          _vm._s(
                                            item.companyName
                                              ? item.companyName
                                              : "暂无企业信息"
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            )
                          })
                        : _c("div", { staticStyle: { "margin-top": "20px" } }, [
                            _vm._v(" 您暂时没有未跟进的客户 "),
                          ]),
                    ],
                    2
                  )
                : _c(
                    "div",
                    { staticClass: "no_contact" },
                    [
                      _vm.contactCustData.length
                        ? _vm._l(_vm.contactCustData, function (item, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "contact_item fix" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "contact_head l" },
                                  [
                                    item.avatar
                                      ? _c("img", {
                                          attrs: {
                                            src: _vm._f("fileWxPath")(
                                              item.avatar
                                            ),
                                            alt: "",
                                          },
                                        })
                                      : _c("a-avatar", {
                                          attrs: {
                                            shape: "square",
                                            size: 55,
                                            icon: "user",
                                          },
                                        }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "customer_details l" },
                                  [
                                    _c("div", { staticClass: "contact_name" }, [
                                      _vm._v(_vm._s(item.custName)),
                                      _c("span", [_vm._v("@微信")]),
                                    ]),
                                    _c("div", { staticClass: "customer_com" }, [
                                      _vm._v(
                                        " 客户企业：" +
                                          _vm._s(
                                            item.companyName
                                              ? item.companyName
                                              : "暂无企业信息"
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            )
                          })
                        : _c("div", { staticStyle: { "margin-top": "20px" } }, [
                            _vm._v(" 您暂时没有跟进中的客户 "),
                          ]),
                    ],
                    2
                  ),
            ]
          ),
        ]),
        _c("div", { staticClass: "box_item l" }, [
          _c("div", { staticClass: "item_title" }, [_vm._v(" 数据简报 ")]),
          _c("div", { staticClass: "item_box" }, [
            _c("div", { staticClass: "item_data fix " }, [
              _c(
                "div",
                { staticClass: "screen_time fix" },
                [
                  _c(
                    "div",
                    { staticClass: "l", staticStyle: { width: "50%" } },
                    [
                      _c("a-range-picker", {
                        attrs: { valueFormat: "YYYY-MM-DD" },
                        model: {
                          value: _vm.dateRange,
                          callback: function ($$v) {
                            _vm.dateRange = $$v
                          },
                          expression: "dateRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-button",
                    {
                      staticClass: "date_screen l",
                      on: { click: _vm.searchDateRange },
                    },
                    [_vm._v("筛选")]
                  ),
                  _c(
                    "a-button",
                    { staticClass: "date_screen l", on: { click: _vm.reset1 } },
                    [_vm._v("重置")]
                  ),
                  _c("div", { staticClass: "search_tips l" }, [
                    _c(
                      "div",
                      { attrs: { id: "components-popover-demo-placement" } },
                      [
                        _c(
                          "a-popover",
                          { attrs: { placement: "bottomRight" } },
                          [
                            _c("template", { slot: "content" }, [
                              _c("p", [
                                _vm._v(
                                  "1.筛选项为新增客户数、新增线索数、新增订车数"
                                ),
                              ]),
                              _c("p", [
                                _vm._v("2.累计客户数累计订车数为累计数量"),
                              ]),
                              _c("p", [
                                _vm._v(
                                  "3.未跟进线索数、公海池线索数、待分配线索数、"
                                ),
                                _c("br"),
                                _vm._v("已分配线索数为实时数量"),
                              ]),
                            ]),
                            _c("div", { staticClass: "tips_img" }, [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/fill.png"),
                                  alt: "",
                                },
                              }),
                            ]),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c("div", { staticClass: "tips_details " }),
              _c("div", { staticClass: "customer_type" }, [
                _vm._m(4),
                _c("div", { staticClass: "customer_data fix" }, [
                  _c("div", { staticClass: "customer_item l" }, [
                    _c(
                      "div",
                      {
                        staticClass: "item_num",
                        on: { click: _vm.customerList },
                      },
                      [_vm._v(_vm._s(_vm.briefingData.newAddCustCount))]
                    ),
                    _c("div", { staticClass: "item_text" }, [
                      _vm._v("新增客户数"),
                    ]),
                  ]),
                  _c("div", { staticClass: "customer_item l" }, [
                    _c(
                      "div",
                      {
                        staticClass: "item_num",
                        on: { click: _vm.customerListAgain },
                      },
                      [_vm._v(_vm._s(_vm.briefingData.sumCustCount))]
                    ),
                    _c("div", { staticClass: "item_text" }, [
                      _vm._v("累计客户数"),
                    ]),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "customer_type" }, [
                _vm._m(5),
                _c("div", { staticClass: "customer_data fix" }, [
                  _c(
                    "div",
                    {
                      staticClass: "customer_item l",
                      on: { click: _vm.cluesList },
                    },
                    [
                      _c("div", { staticClass: "item_num" }, [
                        _vm._v(_vm._s(_vm.briefingData.newAddClueCount)),
                      ]),
                      _c("div", { staticClass: "item_text" }, [
                        _vm._v("新增线索数"),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "customer_item l",
                      on: { click: _vm.cluesListAgain },
                    },
                    [
                      _c("div", { staticClass: "item_num" }, [
                        _vm._v(_vm._s(_vm.briefingData.notFollowRecordCount)),
                      ]),
                      _c("div", { staticClass: "item_text" }, [
                        _vm._v("未跟进线索数"),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "customer_item l",
                      on: {
                        click: function ($event) {
                          return _vm.cluePool(0)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "item_num" }, [
                        _vm._v(_vm._s(_vm.briefingData.cluePoolByAreaCount)),
                      ]),
                      _c("div", { staticClass: "item_text" }, [
                        _vm._v("公海池线索数"),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "customer_item l",
                      on: { click: _vm.clueHis },
                    },
                    [
                      _c("div", { staticClass: "item_num" }, [
                        _vm._v(
                          _vm._s(
                            _vm.briefingData.alreadyAllocationCluePoolCount
                          )
                        ),
                      ]),
                      _c("div", { staticClass: "item_text" }, [
                        _vm._v("已分配线索数"),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "customer_item l",
                      on: {
                        click: function ($event) {
                          return _vm.cluePool(1)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "item_num" }, [
                        _vm._v(
                          _vm._s(_vm.briefingData.waitAllocationCluePoolCount)
                        ),
                      ]),
                      _c("div", { staticClass: "item_text" }, [
                        _vm._v("待分配线索数"),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _c("div", { staticClass: "customer_type" }, [
                _vm._m(6),
                _c("div", { staticClass: "customer_data fix" }, [
                  _c(
                    "div",
                    {
                      staticClass: "customer_item l",
                      staticStyle: { cursor: "pointer" },
                      on: {
                        click: function ($event) {
                          return _vm.toClueList(_vm.briefingData.newClues)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "item_num" }, [
                        _vm._v(_vm._s(_vm.briefingData.newAddOrderCount)),
                      ]),
                      _c("div", { staticClass: "item_text" }, [
                        _vm._v("新增订车数"),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "customer_item l",
                      staticStyle: { cursor: "pointer" },
                      on: {
                        click: function ($event) {
                          return _vm.toClueList(_vm.briefingData.allClues)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "item_num" }, [
                        _vm._v(_vm._s(_vm.briefingData.sumOrderCount)),
                      ]),
                      _c("div", { staticClass: "item_text" }, [
                        _vm._v("累计订车数"),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item_img l" }, [
      _c("img", {
        attrs: { src: require("@/assets/img/daiban.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item_img l" }, [
      _c("img", {
        attrs: { src: require("@/assets/img/loudoutu.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item_img" }, [
      _c("img", {
        attrs: { src: require("@/assets/img/weilianxikehu.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item_img" }, [
      _c("img", {
        attrs: { src: require("@/assets/img/genjinzhongkehu.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "customer_num fix" }, [
      _c("div", { staticClass: "customer_img l" }, [
        _c("img", {
          attrs: { src: require("@/assets/img/kehushu.png"), alt: "" },
        }),
      ]),
      _c("div", { staticClass: "agency_sth l" }, [_vm._v(" 客户数 ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "customer_num fix" }, [
      _c("div", { staticClass: "customer_img l" }, [
        _c("img", {
          attrs: { src: require("@/assets/img/xiansuoshu.png"), alt: "" },
        }),
      ]),
      _c("div", { staticClass: "agency_sth l" }, [_vm._v(" 线索数 ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "customer_num fix" }, [
      _c("div", { staticClass: "customer_img l" }, [
        _c("img", {
          attrs: { src: require("@/assets/img/dingcheshu.png"), alt: "" },
        }),
      ]),
      _c("div", { staticClass: "agency_sth l" }, [_vm._v(" 订车数 ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }